module.exports = __webpack_public_path__ + "img/icon-screens.bb2e72a8.svg";